/**
 * ============================================================================
 * USER / TENANT SERVICE: Dynamic Images & Image Camp
 * ============================================================================
 * Purpose:
 *   Handles Dynamic Image Template creation, visual canvas elements,
 *   background asset uploads, server-side rendered storage, and dynamic
 *   personalized image WhatsApp campaigns.
 *
 * Database Scope:
 *   Tenant Database (`digi_user_<id>`)
 * ============================================================================
 */

import api from "../../core/services/api";

const dynamicImageService = {
  getTemplates: (params = {}) => {
    return api.get("/tenant/dynamic-images/templates", { params });
  },

  getTemplateById: (id) => {
    return api.get(`/tenant/dynamic-images/templates/${id}`);
  },

  createTemplate: (data) => {
    return api.post("/tenant/dynamic-images/templates", data);
  },

  updateTemplate: (id, data) => {
    return api.put(`/tenant/dynamic-images/templates/${id}`, data);
  },

  deleteTemplate: (id) => {
    return api.delete(`/tenant/dynamic-images/templates/${id}`);
  },

  uploadAsset: (formData) => {
    return api.post("/tenant/dynamic-images/upload-asset", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  saveRenderedImage: (data) => {
    return api.post("/tenant/dynamic-images/save-rendered", data);
  },

  sendDynamicCampaign: (data) => {
    return api.post("/tenant/dynamic-images/send-campaign", data);
  },
};

export default dynamicImageService;
